// extracted by mini-css-extract-plugin
module.exports = {"landingWrapper":"NewHome_landingWrapper__16Tx4","sectionContainer":"NewHome_sectionContainer__26XNu"};